@use '@lib/assets/styles/main.scss' as *;

.iconWrap {
  width: 24px;
}

.icon {
  width: 24px;
  height: 24px;
  display: block;
}
